import React from 'react';
import { History, Phone } from 'lucide-react';

const formatDuration = (seconds) => {
  const mins = Math.floor((seconds || 0) / 60);
  const secs = (seconds || 0) % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

export const RecentCallsList = ({ callHistory, t }) => {
  if (!callHistory.length) return null;
  return (
    <div className="bg-[#0d1117] border border-gray-800 rounded-xl p-6 mb-8" data-testid="recent-calls-list">
      <div className="flex items-center gap-2 mb-6">
        <History className="w-5 h-5 text-teal-400" />
        <h2 className="text-lg font-semibold text-white">{t('userDashboard.recentCalls')}</h2>
      </div>
      <div className="space-y-3">
        {callHistory.slice(0, 5).map((call) => (
          <div
            key={call.id}
            className="flex items-center justify-between bg-[#1a1a1f] border border-gray-700 rounded-lg p-4"
            data-testid={`recent-call-row-${call.id}`}
          >
            <div className="flex items-center gap-4">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                call.status === 'completed' ? 'bg-green-400/10' : 'bg-yellow-400/10'
              }`}>
                <Phone className={`w-5 h-5 ${call.status === 'completed' ? 'text-green-400' : 'text-yellow-400'}`} />
              </div>
              <div>
                <p className="text-white font-medium">{call.to_number}</p>
                <p className="text-gray-500 text-sm">{call.agent_name}</p>
              </div>
            </div>
            <div className="text-right">
              <p className="text-white">{formatDuration(call.duration_seconds)}</p>
              <p className="text-gray-500 text-xs capitalize">{call.status}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
